import { create as createJss } from 'jss';
import preset from 'jss-preset-default';

export default function () {
  const jss = createJss(preset());
  // normally the id is a counter - for our use case it can be a constant
  jss.id = 1;
  return jss;
}
